import React from 'react'
import { Prompt } from './Prompt'
import { PromptState, PromptType } from '.'

interface PromptContainerProps {
  prompts: PromptType<any, PromptState>[]
}

export const PromptContainer: React.VFC<PromptContainerProps> = ({
  prompts,
}) => {
  return (
    <>
      {prompts.map(prompt => (
        <Prompt key={prompt.id} prompt={prompt} />
      ))}
    </>
  )
}
